import React from "react";

interface Props {
  currentSection: number;
  totalSections: number;
}

const ScrollProgressBar: React.FC<Props> = ({
  currentSection,
  totalSections,
}) => {
  const sectionHeight = 100 / totalSections;
  const heightPercent = sectionHeight * (currentSection + 1); // currentSection is 0-based

  return (
    <div className="fixed top-1/2 right-3 md:right-6 -translate-y-1/2 h-36 md:h-64 w-1.5 md:w-2 bg-gray-300 rounded-full overflow-hidden z-50">
      <div
        id="scroll-progress-bar"
        className="bg-blue-600 w-full transition-all duration-500"
        style={{ height: `${heightPercent}%` }}
      />
    </div>
  );
};

export default ScrollProgressBar;
